import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  const progress = Math.round((comic.latestChapter / comic.totalChapters) * 100);

  return (
    <article className="manga-card-hover group flex w-full flex-col overflow-hidden rounded-2xl bg-background-50">
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-t-2xl">
        <img
          src={comic.cover}
          alt={`${comic.title} 番木瓜漫画人气连载漫画封面`}
          title={`${comic.title} 追更进度${progress}%`}
          className="manga-art h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent"></div>
        <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
          {comic.status}
        </span>
        <span className="absolute bottom-3 left-3 flex items-center gap-1 text-xs font-medium text-white">
          <i className="ri-eye-fill"></i> {comic.views}
        </span>
        <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-md bg-black/40 px-2 py-0.5 text-xs font-semibold text-secondary-300">
          <i className="ri-star-fill text-secondary-400"></i> {comic.rating}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4">
        <h3 className="truncate text-base font-bold text-foreground-950">{comic.title}</h3>
        <p className="mt-1 truncate text-xs text-foreground-500">{comic.author} · {comic.updateDay}更新</p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {comic.genres.slice(0, 2).map((g) => (
            <span key={g} className="rounded-md bg-background-100 px-2 py-0.5 text-xs text-foreground-600">
              {g}
            </span>
          ))}
        </div>

        <div className="mt-4">
          <div className="flex items-center justify-between text-xs">
            <span className="text-foreground-500">已更新 {comic.latestChapter} 话</span>
            <span className="font-semibold text-primary-600">{progress}%</span>
          </div>
          <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-background-100">
            <div
              className="progress-fill h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-600"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>

        <a
          href="#updates"
          className="mt-4 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-lg bg-background-100 py-2.5 text-sm font-semibold text-foreground-800 transition-colors group-hover:bg-primary-500 group-hover:text-background-50"
        >
          <i className="ri-arrow-right-up-line"></i> 开始追更
        </a>
      </div>
    </article>
  );
}